import PropTypes from 'prop-types';
import { forwardRef } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Box, Link } from '@mui/material';
import { APP_NAME } from '../../core/environment/environment';
// @mui

// ----------------------------------------------------------------------

const Logo = forwardRef(({ disabledLink = false, sx, ...other }, ref) => {
  const logo = (
    <Box sx={{ width: 160, height: 40, cursor: 'pointer', ...sx }}>
      <img alt={APP_NAME} src="https://www.quickmart.co.ke/image/site-logo/1?t=1776045101.jpg" style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
    </Box>
  );

  if (disabledLink) {
    return <>{logo}</>;
  }

  return (
    <Link to="/" component={RouterLink} sx={{ display: 'contents' }}>
      {logo}
    </Link>
  );
});

Logo.propTypes = {
  sx: PropTypes.object,
  disabledLink: PropTypes.bool,
};

export default Logo;
